// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

/**
 * CommissionApi - axios parameter creator
 * @export
 */
export const CommissionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Generate commission csv for period
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCommissionCsvForPeriod(period: string, options: any = {}): RequestArgs {
            // verify required parameter 'period' is not null or undefined
            if (period === null || period === undefined) {
                throw new RequiredError('period','Required parameter period was null or undefined when calling generateCommissionCsvForPeriod.');
            }
            const localVarPath = `/v2/commission`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommissionApi - functional programming interface
 * @export
 */
export const CommissionApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Generate commission csv for period
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCommissionCsvForPeriod(period: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<string> {
            const localVarAxiosArgs = CommissionApiAxiosParamCreator(configuration).generateCommissionCsvForPeriod(period, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CommissionApi - factory interface
 * @export
 */
export const CommissionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Generate commission csv for period
         * @param {string} period 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCommissionCsvForPeriod(period: string, options?: any) {
            return CommissionApiFp(configuration).generateCommissionCsvForPeriod(period, options)(axios, basePath);
        },
    };
};

/**
 * CommissionApi - interface
 * @export
 * @interface CommissionApi
 */
export interface CommissionApiInterface {
    /**
     * Generate commission csv for period
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionApiInterface
     */
    generateCommissionCsvForPeriod(period: string, options?: any): AxiosPromise<string>;

}

/**
 * CommissionApi - object-oriented interface
 * @export
 * @class CommissionApi
 * @extends {BaseAPI}
 */
export class CommissionApi extends BaseAPI implements CommissionApiInterface {
    /**
     * Generate commission csv for period
     * @param {string} period 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommissionApi
     */
    public generateCommissionCsvForPeriod(period: string, options?: any) {
        return CommissionApiFp(this.configuration).generateCommissionCsvForPeriod(period, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for CommissionApi
 * Import individual functions for optimal bundle size
 */
/**
 * Generate commission csv for period
 * @param {string} period 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function generateCommissionCsvForPeriod(
    period: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<string> {
    const localVarAxiosArgs = CommissionApiAxiosParamCreator(configuration).generateCommissionCsvForPeriod(period, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

